// extracted by mini-css-extract-plugin
export default {"role-name":"app-roles-RoleModal-RoleModalCreate-RoleModalCreate-module__Jh8m8mizV3OVRRtkw6Zy"};